import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" id="contact">
      <div className="footer-inner">
        <div className="footer-cols">
          <div className="footer-col footer-brand">
            <div className="footer-brand-row">
              <div className="footer-avatar">
                <img src="/Image.png" alt="فيصل القحطاني" />
              </div>
              <div className="footer-brand-text">
                <span className="footer-brand-name">فيصل القحطاني</span>
                <span className="footer-brand-role">مهندس برمجيات</span>
              </div>
            </div>
            <p className="footer-tagline">
              أُحوِّل الأفكار إلى أنظمة موثوقة وحقيقية.
            </p>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">روابط سريعة</h4>
            <ul className="footer-links">
              <li><Link to="/">الرئيسية</Link></li>
              <li><Link to="/works">أعمالي</Link></li>
              <li><Link to="/articles">المقالات</Link></li>
              <li><Link to="/approach">منهجية العمل</Link></li>
              <li><Link to="/#contact">تواصل معي</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">تواصل</h4>
            <ul className="footer-links">
              <li>
                <a href="mailto:faisalturkiq@gmail.com">faisalturkiq@gmail.com</a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/faisal-turki" target="_blank" rel="noopener noreferrer">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="https://x.com/FaisalTurki_" target="_blank" rel="noopener noreferrer">
                  Twitter / X
                </a>
              </li>
            </ul>

            <div className="footer-socials">
              <a
                href="mailto:faisalturkiq@gmail.com"
                className="footer-social"
                aria-label="البريد"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect x="2" y="3.5" width="12" height="9" rx="1.5" stroke="#6B7280" strokeWidth="1.4" />
                  <path d="M3 5L8 9L13 5" stroke="#6B7280" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/in/faisal-turki"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social"
                aria-label="LinkedIn"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect x="2" y="2" width="12" height="12" rx="2" stroke="#6B7280" strokeWidth="1.4" />
                  <circle cx="5" cy="6" r="0.7" fill="#6B7280" />
                  <path d="M5 8V11.5M8 11.5V9.5C8 8.7 8.7 8 9.5 8C10.3 8 11 8.7 11 9.5V11.5" stroke="#6B7280" strokeWidth="1.4" strokeLinecap="round" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span className="footer-copy">
            صُنع بـ <span className="footer-heart">♥</span> بواسطة فيصل القحطاني · © {year}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
